/* eslint-disable react/no-unescaped-entities */

import React from 'react';
import { Box, Typography } from '@mui/material';
import './TermsContent.scss';
import { LightTable } from '../../../theme/components';

function TermsContentDe() {
  return (
    <>
      <Box className="static-bullets" px={1}>
        <Typography variant="h1" mb={1}>
          Allgemeine Geschäftsbedingungen der STÖRK-TRONIC Störk GmbH & Co. KG
          für Nutzung SaaS-Lösung Cloud Connect (Stand 30.08.2024)
        </Typography>
        <Typography variant="h3" color={'primary'} component={'li'}>
          1. Geltungsbereich / Änderungen AGB
        </Typography>
        <ol>
          <Typography component={'li'}>
            1.1. Die Bestimmungen dieser Allgemeinen Geschäftsbedingungen
            („AGB“) gelten für Verträge zwischen der STÖRK-TRONIC Störk GmbH &
            Co. KG (im Folgenden „STÖRK“) und dem Kunden über die Nutzung von
            Software als Software as a Service (SaaS) und die Erbringung von
            IT-spezifischen Dienstleistungen. Dies gilt auch für zukünftige
            Vertragsabschlüsse, selbst wenn eine Bezugnahme auf die AGB nicht
            mehr erfolgt
          </Typography>
          <Typography component={'li'}>
            1.2. Bei Abschluss eines SaaS-Vertrages gelten die AGB nachrangig,
            sofern nicht ausdrücklich bei einer Bestimmung in dem SaaS-Vertrag
            eine hiervon abweichende Regelung festgelegt ist. Diese AGB gelten
            nur gegenüber Unternehmen als eine natürliche oder juristische
            Person oder eine rechtsfähige Personengesellschaft i. S. v. § 14
            BGB, die in Ausübung ihrer gewerblichen oder selbständigen
            beruflichen Tätigkeit handelt sowie gegenüber juristischen Personen
            des öffentlichen Rechts und öffentlich-rechtlichen Sondervermögen
            i.S.v. § 310 Abs. 1 BGB.
          </Typography>
          <Typography component={'li'}>
            1.3. Änderungen oder Ergänzungen sowie entgegenstehende oder von
            diesen Regelungen abweichende Vertragsbedingungen des Kunden gelten
            nur, wenn STÖRK ihnen in Textform und ausdrücklich zugestimmt hat.
            Ist der Kunde damit nicht einverstanden, so muss er STÖRK sofort
            zumindest in Textform darauf hinweisen
          </Typography>
          <Typography component={'li'}>
            1.4. STÖRK ist berechtigt, Regelungen dieser AGB und die
            Bestimmungen des vorrangig geltenden SaaS-Vertrages nach Maßgabe der
            nachstehenden Voraussetzungen anzupassen. Die Anpassungsbefugnis
            erstreckt sich hierbei insbesondere auf Änderungen in Bezug auf (i)
            technische Entwicklungen, (ii) Änderungen der rechtlichen
            Rahmenbedingungen, (iii) Anpassungen der Regelungen zum Umgang mit
            personenbezogenen Daten, (iv) die Beseitigung eines nachträglich
            entstandenen Missverhältnisses der gegenseitig zu erbringenden
            Leistungen oder (v) die Beseitigung von Regelungslücken (z. B. bei
            unvorhersehbaren, veränderten Umständen). STÖRK wird dem Kunden die
            Anpassungen spätestens acht (8) Wochen vor deren Inkrafttreten
            zumindest in Textform mitteilen. Der Kunde kann den Anpassungen mit
            einer Frist von vier Wochen nach Zugang der Mitteilung zumindest in
            Textform widersprechen, ansonsten gilt die Anpassung als genehmigt.
            Hierauf wird STÖRK den Kunden ausdrücklich in der Mitteilung über
            die Anpassung hinweisen. Im Falle des Widerspruchs durch den Kunden
            ist STÖRK berechtigt, zumindest in Textform den mit dem Kunden
            geschlossenen Vertrag außerordentlich binnen einer Frist von zwei
            Wochen, die mit der Mitteilung beginnt, zu kündigen. Anpassungen in
            den AGB, die Leistungserweiterungen, sprachliche Korrekturen,
            Präzisierungen oder Umformulierungen ohne inhaltliche bzw.
            rechtliche Änderungen beinhalten, stellen keine Anpassungen im Sinne
            dieser Regelung dar. STÖRK wird den Kunden über
            Leistungserweiterungen in Textform unterrichten.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          2. Leistungsinhalte / Vertragsschluss / Subunternehmer
        </Typography>
        <ol>
          <Typography component={'li'}>
            2.1. Die vertragsgegenständlichen Leistungen ergeben sich aus dem
            SaaS-Vertrag.
          </Typography>
          <Typography component={'li'}>
            2.2. STÖRK kann die geschuldeten Vertragsleistungen auch durch
            Dritte erbringen lassen. Der Einsatz von Subunternehmern entbindet
            STÖRK nicht von ihrer Verpflichtung gegenüber dem Kunden zur
            vollständigen Vertragserfüllung.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          3. Leistungserbringung / Termine / Höhere Gewalt
        </Typography>
        <ol>
          <Typography component={'li'}>
            3.1. STÖRK erbringt in Abstimmung mit dem Kunden die
            vertragsgegenständlichen Leistungen zu den zumindest in Textform
            vereinbarten Terminen. Termine zur Leistungserbringung dürfen auf
            Seiten von STÖRK nur durch den Projektleiter oder die
            Geschäftsführung zugesagt werden.
          </Typography>
          <Typography component={'li'}>
            3.2. Führt STÖRK auf entsprechenden Auftrag des Kunden eine
            Machbarkeitsstudie für die Inanspruchnahme von SaaS-Dienstleistungen
            durch, wird STÖRK eine positive oder negative Aussage über die
            Leistungserbringung und die Machbarkeit des Auftrags abgeben. Bei
            einem negativen Prüfergebnis wird STÖRK in der Regel den Abschluss
            eines SaaS-Vertrages ablehne. Die Kosten der Machbarkeitsstudie
            gehen unabhängig von den Ergebnissen der Machbarkeitsstudie stets zu
            Lasten des Kunden.
          </Typography>
          <Typography component={'li'}>
            3.3. Solange STÖRK durch ein unvorhergesehenes Ereignis, das auch
            bei Beachtung zumutbarer Sorgfalt nicht abgewendet werden kann
            („höhere Gewalt“), insbesondere bei Naturkatastrophen, Epidemien,
            Pandemien (z. B. Covid-19), Krieg, Blockade, Embargo,
            Energieversorgungs- oder Betriebsstörungen, Energieknappheit,
            behördlichen Anordnungen, gesetzlichen Verboten, Arbeitskampf oder
            sonstigen Fällen höherer Gewalt an der Leistungserbringung gehindert
            ist, gelten die Leistungsfristen um die Dauer der Behinderung und um
            eine angemessene Anlaufzeit nach Ende der Behinderung
            („Leistungsbehinderung“) als verlängert. Für die Dauer der
            Leistungsbehinderung liegt keine Pflichtverletzung vor. STÖRK zeigt
            dem Kunden derartige Leistungsbehinderungen und ihre
            voraussichtliche Dauer unverzüglich mit. Solange STÖRK wegen eines
            solchen Falls höherer Gewalt keine Vertragsleistungen erbringen
            kann, ist der Kunde gleichfalls von der Leistungspflicht befreit.
            Dauert die höhere Gewalt ununterbrochen länger als zwei Monate oder
            wird STÖRK die Leistungserbringung in den Fällen der höheren Gewalt
            unmöglich, werden der Kunde und STÖRK von den jeweils geschuldeten
            Leistungspflichten frei.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          4. Change Requests
        </Typography>
        <ol>
          <Typography component={'li'}>
            4.1. Als Change Request (CR) gelten insbesondere folgende
            Änderungsbegehren, zusätzliche Leistungen oder Erweiterungen, die
            jeweils voraussichtlich zusätzliche Aufwände begründen. CR sind
            zumindest per E-Mail an STÖRK zu richten.
          </Typography>
          <Typography component={'li'}>
            4.2. Sofern der CR aus Sicht von STÖRK umsetzbar und zumutbar ist,
            unterbreitet STÖRK dem Kunden ein verbindliches Angebot. Der Kunde
            hat zeitnah die Annahme oder Ablehnung des Angebotes mitzuteilen.
            Mit der Annahme durch den Kunden wird das Angebot auch hinsichtlich
            Leistungsterminen Vertragsinhalt. Etwaige durch die Prüfung des CR
            und bis zur Angebotsannahme oder -abnahme eingetretene Verzögerungen
            wie Stillstandzeiten im Rahmen der Vertragserfüllung verlängern die
            vertraglich vereinbarte Ausführungsfrist angemessen.
          </Typography>
          <Typography component={'li'}>
            4.3. Die von dem Änderungsverfahren betroffenen Termine werden unter
            Berücksichtigung der Dauer der Prüfung und des auszuführenden CR
            zuzüglich einer angemessenen Anlauffrist verschoben, sofern das von
            dem Kunden angenommene Angebot von STÖRK nicht entsprechende
            Regelungen zur Verschiebung der Leistungszeit enthält. STÖRK wird
            dem Kunden die neuen Termine zumindest in Textform mitteilen.
            Erfolgt keine Auftragserteilung durch den Kunden, verbleibt es beim
            ursprünglichen Leistungsumfang.
          </Typography>
          <Typography component={'li'}>
            4.4. ie Tätigkeiten von STÖRK für die Prüfung des CR, das Anfertigen
            eines Konzepts oder das Erstellen eines Angebots sowie etwaige
            Stillstandzeiten hat der Kunde gemäß den in der vereinbarten
            Preisliste aufgeführten Preisen zu tragen.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          5. Mitwirkungspflichten des Kunden
        </Typography>
        <ol>
          <Typography component={'li'}>
            5.1. Die Mitarbeit des Kunden ist für von STÖRK geschuldeten
            Vertragsleistungen von wesentlicher Bedeutung.
          </Typography>
          <Typography component={'li'}>
            5.2. Der Kunde hat gegenüber STÖRK bei der Erfüllung seiner
            vertraglich geschuldeten Leistungen insbesondere die in lit. a. bis
            h. aufgeführten Mitwirkungspflichten unentgeltlich zu erbringen:
          </Typography>
          <ol>
            <Typography component={'li'}>
              a. Der Kunde stellt für die Dauer der Vertragsleistungen die
              erforderliche Anzahl kompetenter, fachlich qualifizierter,
              projektspezifisch erfahrener und entscheidungsbefugter
              Mitarbeitenden bereit. Für die hierbei von dem Kunden
              wahrzunehmenden Funktionen sind bei Vertragsbeginn entsprechende
              Mitarbeitende zu benennen. Der Austausch benannter und zur
              Verfügung gestellter Mitarbeitenden ist dem Kunden aus wichtigen
              betrieblichen Gründen gestattet. Für die Vertragsdurchführung
              notwendige Entscheidungen trifft der Kunde unmittelbar nach
              Mitteilung des Entscheidungsbedarfs durch STÖRK.
            </Typography>
            <Typography component={'li'}>
              b. Der Kunde ist verpflichtet die für die Erbringung der
              Vertragsleistungen erforderlichen Tätigkeiten von STÖRK nach
              besten Kräften zu unterstützen. Dies beinhaltet vor allem die
              aktive Teilnahme an allen Besprechungen.
            </Typography>
            <Typography component={'li'}>
              c. Der Kunde hat alle (technischen) Voraussetzungen im Bereich
              seiner Betriebssphäre zu schaffen, die zur Durchführung der
              Vertragsleistungen erforderlich sind.
            </Typography>
            <Typography component={'li'}>
              d. Der Kunde hat aller relevanten Daten in der von STÖRK
              definierten Form, Art und Weise rechtzeitig für die
              Leistungserbringung bereitzustellen.
            </Typography>
            <Typography component={'li'}>
              e. Der Kunde testet vertragsgegenständliche Leistungen vor deren
              Einsatz eingehend auf Mangelfreiheit und auf Verwendbarkeit
              gegebenenfalls in der bestehenden Hard- und Softwarekonfiguration.
            </Typography>
            <Typography component={'li'}>
              f. Auftretende Mängel sind von dem Kunden an STÖRK per E-Mail
              mitzuteilen, sofern STÖRK kein Ticketsystem verwendet. Der Kunde
              hat die Mangelbeschreibung nach besten Kräften in
              nachvollziehbarer Weise unter Angabe der näheren Umstände ihres
              Auftretens, ihrer Auswirkungen und – soweit der Kunde hierzu
              Aussagen machen kann – der möglichen Ursachen zu dokumentieren und
              nach ihrer Entdeckung innerhalb angemessenen Zeitraums an STÖRK
              mitzuteilen.
            </Typography>
          </ol>
          <Typography component={'li'}>
            5.3. Stehen dem Kunden an STÖRK zu überlassenden Informationen die
            erforderlichen Nutzungsrechte nicht zur Verfügung, wird er STÖRK
            hierüber mit der Übergabe unterrichten. Im Falle der Inanspruchnahme
            von STÖRK durch Dritte wegen der geltend gemachten Verletzung von
            Rechten Dritter hat der Kunde STÖRK von einer Haftung umfassend
            freizustellen.
          </Typography>
          <Typography component={'li'}>
            5.4. Von STÖRK auf entsprechende Beauftragung übernommene
            Mitwirkungsleistungen und anfallende Mehraufwendungen sind gemäß den
            vereinbarten Vergütungssätzen von dem Kunden zu vergüten.
          </Typography>
          <Typography component={'li'}>
            5.5. Kommt der Kunde einer Mitwirkungspflicht nicht nach, die für
            eine von STÖRK geschuldete Leistung erforderlich ist, ist STÖRK
            berechtigt, die Leistungserbringung bis zur Nachholung dieser
            Mitwirkungspflicht vorübergehend einzustellen. Vereinbarte
            Fertigstellungszeitpunkte verschieben sich entsprechend zuzüglich
            einer angemessenen Anlauffrist. Kommt der Kunde der geschuldeten
            Mitwirkungspflicht auch nach angemessener Fristsetzung mit
            Ablehnungsandrohung nicht nach, ist STÖRK berechtigt, den Vertrag
            mit sofortiger Wirkung zu kündigen. In diesem Falle ist sie weiter
            berechtigt, alle bis dahin angefallenen Arbeiten nach Aufwand gemäß
            der zwischen den Parteien vereinbarten Vergütung bzw. nach der
            Preisliste von STÖRK abzurechnen.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          6. Abnahme
        </Typography>
        <ol>
          <Typography component={'li'}>
            6.1. Sofern es sich bei den von STÖRK geschuldeten Tätigkeiten um
            werkvertragliche Leistungen handelt, sind diese abschnittsweise oder
            einmalig mit Leistungserbringung von dem Kunden nach Maßgabe der
            nachfolgenden Bestimmungen abzunehmen. Nach Fertigstellung der für
            einen einzelnen Abschnitt beschriebenen Leistungen oder der
            Gesamtleistung teilt STÖRK die Abnahmereife mit. Die Abnahme ist
            erfolgreich durchgeführt, wenn betreffend den werkvertraglichen
            Leistungen keine wesentlichen Mängel vorliegen. Eine Teilabnahme
            bezieht sich lediglich auf die Mangelfreiheit der Teilleistung. Das
            Zusammenspiel der Teilleistungen (Gesamt-Funktionalität) wird erst
            mit Endabnahme festgestellt.
          </Typography>
          <Typography component={'li'}>
            6.2. Liegen keine abnahmehindernden wesentlichen Mängel vor, hat der
            Kunde die Leistungen abzunehmen. Beurteilt der Kunde die erbrachten
            Leistungen nicht als im Wesentlichen vertragsgemäß, so hat er seine
            Beanstandungen innerhalb von 3 Werktagen (Mo. – Fr.) STÖRK zumindest
            in Textform mitzuteilen.
          </Typography>
          <Typography component={'li'}>
            6.3. Beanstandet der Kunde die Leistungen frist- und vertragsgemäß,
            werden bestehende Mängel an der Eigensoftware von STÖRK innerhalb
            angemessener Zeit beseitigt. Über Mängel an Drittsoftware
            (Fremdsoftware) wird STÖRK den jeweiligen Softwarehersteller zur
            Durchfügung der Mangelbeseitigung unterrichten.
          </Typography>
          <Typography component={'li'}>
            6.4. Die Abnahme gilt als erfolgt, sofern der Kunde nicht innerhalb
            der Frist gemäß Ziffer 6.2. nach der Aufforderung von STÖRK
            zumindest in Textform die Gründe für die Verweigerung der Abnahme
            spezifiziert. Die Abnahme gilt ebenfalls als erfolgt, sofern der
            Kunde die von STÖRK erbrachten Leistungen über die Dauer von mehr
            als 2 Werktage in Benutzung nimmt.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          7. Nutzungsrechte
        </Typography>
        <ol>
          <Typography component={'li'}>
            7.1. Anleitungen, Dokumentationen, elektronische Präsentationen und
            sonstige Schriftstücke, die STÖRK im Rahmen der Vertragserfüllung
            erstellt, sind dem Kunden auf Anforderung in Kopie zur
            vertragsmäßigen Verwendung für eigene Zwecke zu überlassen. Der
            Kunde ist verpflichtet, bestehende gesetzliche Schutzrechte zu
            beachten.
          </Typography>
          <Typography component={'li'}>
            7.2. STÖRK räumt dem Kunden an Arbeitsergebnissen, wie Konzepten und
            Pflichtenheften, ein einfaches dauerhaftes nicht übertragbares Recht
            zur bestimmungsgemäßen Nutzung für eigene Zwecke ein.
          </Typography>
          <Typography component={'li'}>
            7.3. Die SaaS-Lösung ist urheberrechtlich geschützt. Die SaaS-Lösung
            kann Open- Source-Softwaretools enthalten. Diese unterliegen den
            jeweiligen Open-Source- Lizenzbedingungen, die in der SaaS-Lösung
            hinterlegt sind. Ist auch Vertragsgegenstand die
            Zurverfügungstellung von Drittsoftware und gelten hierfür nicht die
            nachstehenden Nutzungsrechtsregelungen, bestimmt sich die
            Rechteeinräumung für den Kunden nach den Lizenzbestimmungen des
            Lizenzgebers der Drittsoftware
            .....................................................................
            Die Lizenzbestimmungen für die Drittsoftware können auf der Website
            der jeweiligen Lizenzgeber aufgerufen werden.
          </Typography>
          <Typography component={'li'}>
            7.4. STÖRK räumt dem Kunden an angepasster oder erstellter Software
            sowie bei Überlassung im Standard als on-premise-Lösung im
            Objektcode mit vollständiger Bezahlung der vereinbarten Vergütung
            ein einfaches Recht zur bestimmungsgemäßen Nutzung ein. Bis zur
            Zahlung der geschuldeten Vergütung zum jeweils vereinbarten
            Zeitpunkt wird dem Kunden ein einfaches, bei Zahlungsverzug von mehr
            als 30 Tagen widerrufliches Nutzungsrecht eingeräumt.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          8. Datenschutz / Geheimhaltung
        </Typography>
        <ol>
          <Typography component={'li'}>
            8.1. STÖRK wird im Rahmen der Vertragserfüllung sämtliche jeweils
            anzuwendenden datenschutzrechtlichen Bestimmungen - insbesondere die
            Datenschutz- Grundverordnung (DSGVO) und das Bundesdatenschutzgesetz
            (BDSG) - wahren. Einzelheiten zur Datenverarbeitung und der
            Betroffenenrechte können den Datenschutzhinweisen und der
            Datenschutzerklärung unter{' '}
            <a href="https://www.st-cloudconnect.com/privacy">
              https://www.st-cloudconnect.com/privacy
            </a>{' '}
            entnommen werden.
          </Typography>
          <Typography component={'li'}>
            8.2. Die Vertragsparteien werden die datenschutzrechtlichen
            Verpflichtungen auch ihren Mitarbeitenden und eventuell eingesetzten
            Subunternehmern auferlegen.
          </Typography>
          <Typography component={'li'}>
            8.3. Der Kunde wird bei der Nutzung der von STÖRK erbrachten
            Vertragsleistungen die anwendbaren datenschutzrechtlichen
            Bestimmungen einhalten. STÖRK ist insoweit nicht Verantwortlicher im
            Sinne des Art. 4 Nr. 7 DSGVO.
          </Typography>
          <Typography component={'li'}>
            8.4. Die Vertragsparteien sind sich einig, einen separaten Vertrag
            zur Auftragsverarbeitung mit den im Rahmen der Auftragsverarbeitung
            bestehenden Pflichten und Rechte des Kunden zu schließen, sofern
            STÖRK im Rahmen der Vertragsdurchführung auftragsgemäß
            personenbezogene Daten des Kunden oder dessen Kunden (Anwender)
            verarbeitet.
          </Typography>
          <Typography component={'li'}>
            8.5. STÖRK verpflichtet sich, mit allen von ihm im Zusammenhang mit
            der Vorbereitung, Durchführung und Erfüllung des Vertrages mit dem
            Kunden eingesetzten Mitarbeitenden und Subunternehmen eine mit
            vorstehender Ziffer 8.2. inhaltsgleiche Regelung zu vereinbaren.
          </Typography>
          <Typography component={'li'}>
            8.6. Soweit die Vertragsparteien eine Geheimhaltungsvereinbarung
            (NDA) geschlossen haben, gehen deren Bestimmungen den nachfolgenden
            Regelungen vor. Im Übrigen verpflichten sich die Vertragsparteien,
            alle ihnen bei der Vertragsdurchführung von der jeweils anderen
            Partei zugehenden oder bekannt werdenden Geschäftsgeheimnisse oder
            als vertraulich bezeichnete Informationen (zusammen als
            „Informationen“ bezeichnet) für die Dauer der Vertragsdurchführung
            auch über das Vertragsende hinaus für drei weitere Jahre geheim zu
            halten und die jeweiligen Mitarbeitenden entsprechend zu
            verpflichten. Die Informationen dürfen an der Vertragsdurchführung
            nicht beteiligten unternehmensfremden Dritten nicht zugänglich
            gemacht werden. Die Vertragsparteien sichern die Informationen wie
            dies mit eigenen schutzwürdigen Informationen geschieht. Mit den
            Vertragsparteien im Sinne von §§ 15 ff. AktG verbundene Unternehmen
            sind keine Dritten im Sinne dieser Vorschrift
          </Typography>
          <Typography component={'li'}>
            8.7. Die in Ziffer 8.6. aufgeführten Verpflichtungen der
            Vertragsparteien gelten nicht für Informationen, die (i) zur Zeit
            ihrer Übermittlung durch die offenlegende Partei bereits offenkundig
            oder der empfangenden Partei bekannt waren; (ii) nach ihrer
            Übermittlung durch die offenlegende Partei ohne Verschulden der
            empfangenden Partei offenkundig geworden sind; (iii) welche die
            empfangenden Partei nachweisbar von dritter Seite auf nicht
            rechtswidrige Weise und ohne Einschränkung in Bezug auf
            Geheimhaltung oder Verwertung erhalten hat; iv) die von der
            empfangenden Partei eigenständig, ohne Nutzung der Informationen der
            offenlegenden Partei, entwickelt worden sind; (v) die gemäß Gesetz,
            behördlicher Verfügung oder gerichtlicher Entscheidung
            veröffentlicht werden müssen – vorausgesetzt, die empfangende
            informiert die offenlegende Partei hierüber unverzüglich und
            unterstützt sie in der Abwehr derartiger Verfügungen bzw.
            Entscheidungen - oder (vi) soweit der empfangenden Partei die
            Nutzung oder Weitergabe der Informationen auf Grund zwingender
            gesetzlicher Bestimmungen oder auf Grund des Vertrages zwischen den
            Vertragsparteien gestattet ist.
          </Typography>
          <Typography component={'li'}>
            8.8. STÖRK ist es gestattet, den Kunden als Referenzvertragspartei
            zu benennen und hierzu auch dessen Logo zu verwenden.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          9. Vergütung und Zahlungsbedingungen
        </Typography>
        <ol>
          <Typography component={'li'}>
            9.1. Die Höhe der Vergütung für die von STÖRK zu erbringenden
            Vertragsleistungen und die Zahlungsbedingungen (Zahlungstermine)
            sind im SaaS-Vertrag festgehalten.
          </Typography>
          <Typography component={'li'}>
            9.2. STÖRK hat neben der vereinbarten Vergütung bei entsprechender
            Festlegung im Einzelfall auch Anspruch auf Ersatz der Nebenkosten
            bzw. Auslagen wie insbesondere der Erstattung angemessener Reise-
            und Übernachtungskosten. Nebenkosten werden sodann dem Kunden auch
            in Rechnung gestellt.
          </Typography>
          <Typography component={'li'}>
            9.3. Die von STÖRK in Rechnung gestellten Beträge sind mit
            Rechnungseingang beim Kunden zur Zahlung fällig und innerhalb von 14
            Kalendertagen ohne Abzüge zahlbar. Für die Rechtzeitigkeit einer
            Zahlung ist der Tag der Wertstellung auf dem empfangenden Konto
            maßgebend.
          </Typography>
          <Typography component={'li'}>
            9.4. Gerät der Kunde mit seiner Zahlungsverpflichtung in Verzug, ist
            STÖRK berechtigt, Verzugszinsen entsprechend den gesetzlichen
            Bestimmungen zu verlangen. Unbeschadet bleibt STÖRK die
            Geltendmachung weiterer Schadensersatzansprüche, wie insbesondere
            höhere Zinsen, Mehrkosten und angemessener Mahngebühren. Der Kunde
            ist jedoch berechtigt den Nachweis zu führen, dass STÖRK überhaupt
            kein oder ein niedrigerer Schaden entstanden ist.
          </Typography>
          <Typography component={'li'}>
            9.5. Sämtliche Beträge verstehen sich netto zzgl. der zum Zeitpunkt
            der Leistungserbringung geltenden gesetzlichen Umsatzsteuer.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          10. Sach- und Rechtsmängel für Erbringung IT-spezifische
          Dienstleistungen
        </Typography>
        <ol>
          <Typography component={'li'} fontWeight={'bold'}>
            10.1. Mangeldefinition
          </Typography>
          <Typography component={'li'}>
            Technische Daten, Spezifikationen und Leistungsangaben in
            öffentlichen Äußerungen, insbesondere in Werbemitteln sind keine
            Beschaffenheitsangaben. STÖRK gewährleistet die Funktions- und
            Betriebsbereitschaft des Vertragsgegenstandes gemäß den vereinbarten
            Anforderungen. Im Übrigen muss sich der Vertragsgegenstand für die
            nach dem geschlossenen Vertrag vorausgesetzte Verwendung eignen und
            ansonsten eine Beschaffenheit aufweisen, die bei einem
            Vertragsgegenstand der gleichen Art üblich ist. Ein Rechtsmangel
            liegt vor, wenn dem Kunden für die vertragliche Verwendung des
            Vertragsgegenstandes Europa, USA und Kanada die erforderlichen
            Rechte nicht wirksam eingeräumt werden konnten
          </Typography>
          <Typography component={'li'} fontWeight={'bold'}>
            10.2. Änderungen durch Kunden
          </Typography>
          <Typography component={'li'}>
            Sofern durch den Kunden oder von ihm beauftragte Dritte – ohne die
            Einwilligung von STÖRK zumindest in Textform – Eingriffe in den von
            STÖRK gelieferten Vertragsgegenstand oder der erbrachten
            Werkleistung vorgenommen werden, insbesondere Manipulationen oder
            sonstige Änderungen, leistet STÖRK nur dann Mangelbeseitigung, wenn
            der Kunde nachweist, dass der Eingriff in keinem Zusammenhang mit
            dem aufgetretenen Mangel steht und Analyse sowie Behebung nicht
            erschweren
          </Typography>
          <Typography component={'li'} fontWeight={'bold'}>
            10.3. Ausschluss der Nacherfüllung
          </Typography>
          <Typography component={'li'}>
            Der Anspruch des Kunden auf Nacherfüllung ist ausgeschlossen, wenn
            der Mangel nicht reproduzierbar ist bzw. anhand von handschriftlich
            oder maschinell festgehaltenen Ausdrucken nicht aufgezeigt werden
            kann.
          </Typography>
          <Typography component={'li'}>
            10.4. Erbringt STÖRK Leistungen bei der Mangelsuche oder
            –beseitigung, ohne hierzu verpflichtet zu sein, so kann sie hierfür
            Vergütung gemäß den vereinbarten Vergütungssätzen verlangen. Das
            gilt insbesondere, wenn ein Mangel nicht nachweisbar oder STÖRK
            nicht zuzurechnen ist. Zu vergüten ist STÖRK außerdem ein
            Mehraufwand, der dadurch entsteht, dass der Kunde seinen
            Mitwirkungspflichten nicht vertragsgemäß nachkommt.
          </Typography>
          <Typography component={'li'} fontWeight={'bold'}>
            10.5. Nacherfüllung bei Rechtsmängeln
          </Typography>
          <Typography component={'li'}>
            Die Nacherfüllung bei Rechtsmängeln erfolgt nach Wahl von STÖRK,
            entweder (i) indem dem Kunden eine rechtlich einwandfreie
            Nutzungsmöglichkeit an der Vertragsleistung verschafft wird, (ii)
            die schutzrechtverletzende Vertragsleistung ohne bzw. nur mit für
            den Kunden akzeptablen Auswirkungen auf deren Funktion geändert
            wird, (iii) die schutzrechtsverletzende Vertragsleistung ohne bzw.
            nur mit für den Kunden akzeptablen Auswirkungen auf deren Funktion
            gegen eine Vertragsleistung austauscht wird, deren vertragsgemäße
            Nutzung keine Schutzrechte verletzt, oder (iv) STÖRK bei Software
            einen neuen Programmstand liefert, bei dessen vertragsgemäßer
            Nutzung keine Rechte Dritter verletzt werden.
          </Typography>
          <Typography component={'li'}>
            Falls Dritte Schutzrechte gegen den Kunden geltend machen, hat
            dieser STÖRK unverzüglich in Textform zu unterrichten. STÖRK kann
            nach eigener Wahl die Ansprüche abwehren oder befriedigen. Der Kunde
            darf von sich aus die Ansprüche Dritter nicht anerkennen. STÖRK
            stellt den Kunden von allen mit der Anspruchsabwehr verbundenen
            gesetzlichen Kosten und Schäden frei, soweit STÖRK den Rechtsmangel
            zu vertreten hat, dieser nicht auf einem pflichtwidrigen Verhalten
            des Kunden beruht und der Kunde seiner unverzüglich auszuführenden
            Unterrichtungsverpflichtung nachkam.
          </Typography>
          <Typography component={'li'} fontWeight={'bold'}>
            10.6. Arglist / Garantie
          </Typography>
          <Typography component={'li'}>
            Im Falle von Arglist und bei Übernahme einer Garantie durch STÖRK
            bleiben die gesetzlichen Bestimmungen für Sach- und Rechtsmängel
            unberührt.
          </Typography>
          <Typography component={'li'} fontWeight={'bold'}>
            10.7. Ansprüche bei sonstigen Pflichtverletzungen
          </Typography>
          <Typography component={'li'}>
            Aus sonstigen Pflichtverletzungen von STÖRK kann der Kunde Rechte
            nur her- leiten, wenn sie diese gegenüber STÖRK zumindest in
            Textform gerügt und ihr eine Nachfrist zur Abhilfe eingeräumt hat.
            Das gilt nicht, soweit nach der Art der Pflichtverletzung eine
            Abhilfe nicht in Betracht kommt. Für Schadensersatz oder Ersatz
            vergeblicher Aufwendungen gelten die in Ziffer 11 festgelegten
            Grenzen.
          </Typography>
          <Typography component={'li'} fontWeight={'bold'}>
            10.8. Verjährungsfristen
          </Typography>
          <Typography component={'li'}>
            Die Verjährungsfrist für Mangelbeseitigungsansprüche beträgt ein
            Jahr. Die Verjährung beginnt mit dem Nutzungsbeginn der
            Vertragsleistung, Bei Vorsatz oder grober Fahrlässigkeit von STÖRK,
            bei arglistigem Verschweigen des Mangels, bei Personenschäden oder
            Rechtsmängeln, bei Ansprüchen nach dem Produkthaftungsgesetz sowie
            bei Garantien gelten die gesetzlichen Verjährungsfristen.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          11. Haftung
        </Typography>
        <ol>
          <Typography component={'li'}>
            11.1. STÖRK haftet gegenüber dem Kunden nach den gesetzlichen
            Bestimmungen, sofern der Kunde Schadens- oder
            Aufwendungsersatzansprüche geltend macht, die auf Vorsatz oder
            grober Fahrlässigkeit von STÖRK beruhen, in den Fällen einer
            schuldhaften Verletzung des Lebens, des Körpers oder der Gesundheit
            oder bei Ansprüchen nach dem Produkthaftungsgesetz. Dies gilt auch
            bei arglistigem Verschweigen eines Mangels, bei Übernahme des
            Beschaffungsrisikos im Sinne von § 276 BGB oder bei ausnahmsweiser
            schriftlicher Übernahme einer Beschaffenheitsgarantie gemäß § 443
            BGB.
          </Typography>
          <Typography component={'li'}>
            11.2. Für den Fall, dass Leistungen von STÖRK von unberechtigten
            Dritten unter Verwendung der Zugangsdaten des Kunden in Anspruch
            genommen werden, haftet der Kunde für dadurch anfallende Entgelte im
            Rahmen der zivilrechtlichen Haftung bis zum Eingang des
            Kundenauftrages zur Änderung der Zugangsdaten oder der Meldung des
            Verlusts oder Diebstahls, sofern den Kunden am Zugriff des
            unberechtigten Dritten ein Verschulden trifft.
          </Typography>
          <Typography component={'li'}>
            11.3. Bei einfacher Fahrlässigkeit haftet STÖRK nur, soweit STÖRK
            eine vertragliche Kardinalpflicht verletzt hat. Vertragswesentliche
            Pflichten sind solche, die die Grundlage des Vertrags bilden, die
            entscheidend für den Abschluss des Vertrags waren und auf deren
            Erfüllung der Kunde vertrauen darf. Dabei ist die Haftung von STÖRK
            dabei summenmäßig beschränkt auf die Höhe des vorhersehbaren
            Schadens, mit dessen Entstehung typischerweise gerechnet werden
            muss. Maximal ist diese Haftung von STÖRK jedoch beschränkt pro
            Schadensfall bei SaaS auf die 1,5fache jährliche Vergütung, bei
            werkvertraglicher Leistung auf die doppelte Vergütung sowie bei
            IT-spezifischen Dienstleistungen auf den jeweiligen zweifachen
            Vergütungs- oder entsprechenden Teilvergütungsbetrag (jeweils
            Nettobetrag). Im Übrigen ist die Haftung von STÖRK für Schäden wegen
            leicht fahrlässiger Verletzung sonstiger Vertragspflichten und wegen
            entgangenen Gewinns, personellen Mehraufwandes beim Kunden,
            Nutzungsausfall und/ oder wegen Umsatzeinbußen ausgeschlossen.
          </Typography>
          <Typography component={'li'}>
            11.4. Die verschuldensunabhängige Schadensersatzhaftung für Mängel,
            die bereits bei Vertragsschluss vorhanden waren, ist ausgeschlossen.
          </Typography>
          <Typography component={'li'}>
            11.5. Bei Datenverlusten haftet STÖRK nur für den Schaden, der auch
            bei vertragsgemäßer Datensicherung durch den Kunden entstanden wäre
            und der Kunde seinen Datensicherungspflichten nachkam.
          </Typography>
          <Typography component={'li'}>
            11.6. STÖRK haftet nicht auf Schadensersatz wegen mangelhafter
            vertragsgegenständlicher Fremdsoftware einschließlich Open Source
            Software und Open Source Komponenten („Drittsoftware“) des
            Drittsoftwareherstellers, es sei denn der Sachmangel ist für STÖRK
            erkennbar oder vermeidbar. Eine Zurechnung der Mangelhaftigkeit der
            Drittsoftware nach § 278 BGB auf STÖRK ist ausgeschlossen, sofern
            STÖRK betreffend der Drittsoftware zur Überlassung und
            Rechteeinräumung verpflichtet ist.
          </Typography>
          <Typography component={'li'}>
            11.7. Eine weitergehende Haftung von STÖRK auf Schadens- oder
            Aufwendungsersatz ist ohne Rücksicht auf die Rechtsnatur des geltend
            gemachten Anspruchs ausgeschlossen.
          </Typography>
          <Typography component={'li'}>
            11.8. Soweit nach dem Vorstehenden die Haftung von STÖRK
            ausgeschlossen oder beschränkt ist, gilt dies auch für die Haftung
            der Organe von STÖRK und von Erfüllungs- und Verrichtungsgehilfen,
            insbesondere von Mitarbeitern.
          </Typography>
          <Typography component={'li'}>
            11.9. Der Kunde ist verpflichtet, etwaige Schäden im Sinne
            vorstehender Haftungsregelungen STÖRK unverzüglich schriftlich
            anzuzeigen oder von STÖRK aufnehmen zu lassen, so dass STÖRK
            möglichst frühzeitig informiert wird und eventuell gemeinsam mit dem
            geschädigten Kunden noch Schadensminderung betreiben kann.
          </Typography>
          <Typography component={'li'}>
            11.10. Die Verjährungsfristen sind in Ziffer 10.8. geregelt.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          12. Laufzeit / Kündigung
        </Typography>
        <ol>
          <Typography component={'li'}>
            12.1. Im SaaS-Vertrag sind die Laufzeit und die Kündigungsfrist
            vorrangig geltend geregelt.
          </Typography>
          <Typography component={'li'}>
            12.2. Sofern es sich bei dem Vertrag über die zu erbringende
            Dienstleistung um ein Dauerschuldverhältnis handelt, beginnt der
            Vertrag zu dem vereinbarten Zeitpunkt und läuft auf unbestimmte
            Zeit.
          </Typography>
          <Typography component={'li'}>
            12.3. Bei Dauerschuldverhältnissen gemäß Ziffer 12.2. können beide
            Vertragsparteien den geschlossenen Vertrag jederzeit unter
            Einhaltung einer Frist von drei Monaten zum Monatsende kündigen.
          </Typography>
          <Typography component={'li'}>
            12.4. Im Falle einer fristgerechten Kündigung wird die Vergütung wie
            folgt geregelt: Für die bis dahin erbrachten Leistungen wird die
            volle Vergütung fällig. Für die in Folge der vorzeitigen Beendigung
            nicht zu erfüllenden Leistungen entfällt der Vergütungsanspruch, es
            sei denn der Kunde hat die Kündigung zu vertreten. Im Falle der
            Kündigung eines Werkvertrages durch den Kunden nach § 648 BGB, kann
            STÖRK nach ihrer Wahl die Ansprüche nach § 648 BGB oder stattdessen
            für ihre Aufwendungen und den entgangenen Gewinn neben der Vergütung
            für die schon erbrachten Leistungen einen Pauschalbetrag i. H. v. 50
            % der für die zum Zeitpunkt der Kündigung noch nicht erbrachten
            jeweiligen Leistungen als Vergütung – bezogen auf diesen Vertrag -
            verlangen.
          </Typography>
          <Typography component={'li'}>
            STÖRK bleibt es vorbehalten nachzuweisen, dass der ihr nach § 648
            BGB zustehende Betrag höher ist. Der Kunde hat seinerseits das Recht
            den Nachweis zu führen, dass der Pauschalbetrag zugunsten vom STÖRK
            geringer ist.
          </Typography>
          <Typography component={'li'}>
            12.5. Unberührt bleibt für beide Vertragsparteien das Recht zur
            fristlosen Kündigung des Vertrages bei Vorliegen eines wichtigen
            Grundes. Ein wichtiger Grund liegt insbesondere dann vor,
          </Typography>
          <ol>
            <Typography component={'li'}>
              - sofern eine Vertragspartei andauernd und wiederholt trotz
              Abmahnung gegen Pflichten aus dem Vertrag oder gegen die
              nachrangig ergänzend geltenden Bestimmungen der Allgemeinen
              Geschäftsbedingungen verstößt;
            </Typography>
            <Typography component={'li'}>
              - wenn der Kunde mit der Zahlung der Vergütung um mehr als einen
              Monat in Verzug ist;
            </Typography>
            <Typography component={'li'}>
              - bei dem Kunden eine wesentliche Vermögensgefährdung oder
              Vermögensverschlechterung eintritt, die zu einem
              Creditreform-Bonitätsindex von 490 oder schlechter führt;
            </Typography>
            <Typography component={'li'}>
              - wenn über das Vermögen der anderen Vertragspartei das
              Insolvenzverfahren eröffnet oder die Eröffnung des
              Insolvenzverfahrens mangels Masse abgelehnt wird.
            </Typography>
          </ol>
          <Typography component={'li'} fontWeight={'bold'}>
            Besondere Bestimmungen für SaaS-Vertrag
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          13. Datensicherung durch STÖRK und Kunde
        </Typography>
        <ol>
          <Typography component={'li'}>
            13.1. STÖRK trägt dafür Sorge, dass die Sensor- und Ereignisdaten
            automatisch gespeichert werden gemäß den Festlegungen in § 2 Abs. 4
            lit. b. des SaaS- Vertrages.
          </Typography>
          <Typography component={'li'}>
            13.2. STÖRK verpflichtet sich die Sensor- und Ereignisdaten vor dem
            Zugriff durch unbefugte Dritte zu schützen.
          </Typography>
          <Typography component={'li'}>
            13.3. Der Kunde räumt STÖRK das Recht ein, die von ihm gespeicherten
            Sensor- und Ereignisdaten zum Zwecke der Vertragserfüllung zu
            verarbeiten und zu vervielfältigen (insbesondere Datensicherung),
            soweit dies zur Erbringung der von STÖRK vertraglich geschuldeten
            Leistungen oder aus Sicherheitsgründen erforderlich ist. STÖRK ist
            auch berechtigt, die Sensor- und Ereignisdaten in einem
            Ausfallrechenzentrum in der Europäischen Union vorzuhalten. Zur
            Beseitigung von Störungen ist STÖRK zudem berechtigt, Änderungen an
            der Struktur Sensor- und Ereignisdaten oder dem Datenformat
            vorzunehmen. Der Kunde ist im Übrigen Alleinberechtigter der Sensor-
            und Ereignisdaten.
          </Typography>
          <Typography component={'li'}>
            13.4. Der Kunde ist verpflichtet, jeweils rechtzeitig vor Ablauf der
            12-Monatsfrist gemäß § 2 Abs. 4 lit. b iv des SaaS-Vertrages die
            Sensor- und Ereignisdaten in einem gängigen verarbeitbaren
            Datenformat auf seine Hardware herunterladen. Der Kunde hat keinen
            Anspruch darauf, auch die zur Verwendung der Daten geeignete
            Software zur Nutzung zu erhalten.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          14. Verfügbarkeit Cloud Connec
        </Typography>
        <ol>
          <Typography component={'li'}>14.1. Verfügbarkeit</Typography>
          <Typography component={'li'}>
            STÖRK gewährleistet eine Verfügbarkeit der Funktionalitäten von
            Cloud mit einem monatlichen Verfügbarkeitsprozentsatz [1] von
            mindestens 98,5 %
          </Typography>
          <Typography component={'li'}>
            [1] Der "monatliche Verfügbarkeitsprozentsatz" wird berechnet, indem
            der Prozentsatz der Minuten, in denen Cloud Connect als
            Rechnerinstanz nicht verfügbar war, von 100 % abgezogen wird.
          </Typography>
          <Typography component={'li'}>
            14.2. Die monatliche Verfügbarkeit von Cloud Connect bemisst sich
            gemäß den Vorgaben in § 2 Abs. 2 des SaaS-Vertrages abzüglich
            geplanten sowie ungeplanten Support gemäß den Regelungen in Ziffer
            14.4. und 14.5. wie folgt:
          </Typography>
          <Typography component={'li'}>
            <LightTable
              columns={[
                {
                  field: 'availability',
                  headerName: 'Monatlicher Verfügbarkei',
                },
                {
                  field: 'availability_minutes',

                  headerName: 'Maximale monatliche Verfügbarkeit in Minuten',
                },
                {
                  field: 'availability_downtime',

                  headerName: 'Maximale erlaubte Ausfallzeit in Minuten',
                },
              ]}
              rows={[
                {
                  availability: '100.0%',
                  availability_minutes: '30.44 T * 24 h* 60 min = 43834 min',
                  availability_downtime: '0',
                },
                {
                  availability: '98.5%',
                  availability_minutes: '43176 min',
                  availability_downtime: '658 min',
                },
              ]}
            ></LightTable>
          </Typography>
          <Typography component={'li'}>
            14.3. Verfügbarkeitskontrolle / Monitoring
          </Typography>
          <Typography component={'li'}>
            Die Kontrolle und das Monitoring der Verfügbarkeit von Cloud Connect
            erfolgt durch eine unabhängige Rechnerinstanz, welche kontinuierlich
            die jeweilige Verfügbarkeit insbesondere der Funktionen
            Gerätemanager, Datenspeicherung und Alarmierung (im Folgenden
            zusammen als „Funktionen“) von Cloud Connect, überprüft. Diese
            Rechnerinstanz ist in einem anderen Serverbereich als Cloud Connect
            gehostet, damit eine unabhängige Kontrolle der Verfügbarkeit von
            Cloud Connect als Funktionsinstanz gewährleistet ist. "Nicht
            verfügbar" und "Nichtverfügbarkeit" bedeuten, dass Cloud Connect als
            SaaS-Lösung eine der Funktionen nicht mehr erfüllen kann.
          </Typography>
          <Typography component={'li'}>
            14.4. STÖRK ist berechtigt, die Verfügbarkeit auf Grund von
            technisch dringend, unvorhersehbar notwendige Supportleistungen zur
            Instandhaltung und Instandsetzung von Cloud Connect, insbesondere
            aufgrund einer Gefährdung der Systemsicherheit des Servers, temporär
            einzuschränken (ungeplanter Support). Als Supportleistung gilt
            insbesondere Security-Bugfixing, die Behebung von
            Sicherheits-Problemen extern erreichbarer Komponenten, namentlich,
            Webserver, Datenbanken, sicherheitsrelevante Systembibliotheken
            (Libraries), Abwehrmaßnahmen gegen Cyber-Angriffe, der Austausch
            defekter Hardware, Maßnahmen gegen Sabotage u.ä.. Im Rahmen solcher
            Maßnahmen ist insbesondere das Rebooting von Servern zulässig. STÖRK
            ist berechtigt, ungeplante Supportleistungen nach eigenem,
            pflichtgemäßem Ermessen und ohne vorherige Rücksprache mit dem
            Kunden durchzuführen. Alle Tätigkeiten sind zu dokumentieren und dem
            Kunden unaufgefordert und zeitnah mitzuteilen.
          </Typography>
          <Typography component={'li'}>
            14.5. STÖRK ist weiterhin berechtigt, die Verfügbarkeit auf Grund
            von technisch notwendiger, planbarer Supportleistungen zur
            Instandhaltung der vertragsgemäßen Leistungen temporär
            einzuschränken (geplanter Support). Als Support gilt insbesondere
            das Einspielen neuen Programmständen, der Austausch von Hardware
            auf/in Komponenten der SaaS-Infrastruktur. Im Übrigen dürfen
            Anpassungen, Änderungen oder Ergänzungen der Software sowie
            Maßnahmen, die der Feststellung und Behebung von Funktionsstörungen
            (insbesondere Mangelbeseitigungen), nur dann zu einer
            vorübergehenden Unterbrechung oder Beeinträchtigung der
            Erreichbarkeit führen, wenn dies aus technischen Gründen notwendig
            ist.
          </Typography>
          <Typography component={'li'}>
            14.6. STÖRK ist verpflichtet, alle für sie wirtschaftlich und
            technisch zumutbaren Anstrengungen zu unternehmen, ungeplante und
            geplante Supportleistungen jeweils so kurz wie möglich zu halten und
            so schnell wie wirtschaftlich und personell möglich abzuschließen.
            STÖRK hat es stets und in jedem Fall zu unterlassen, geplante
            Supportleistungen willkürlich anzusetzen und/oder durchzuführen.
            STÖRK wird den Kunden rechtzeitig und zumindest in Textform auf
            geplanten Support und daraus resultierende, vorhersehbare
            Einschränkung der Verfügbarkeit hinweisen.
          </Typography>
          <Typography component={'li'}>
            14.7. STÖRK stimmt mit dem Kunden Zeiten geplanten Supports vorab ab
            und wird die Interessen des Kunden an einem ordnungsgemäßen
            Geschäftsbetrieb berücksichtigen, soweit dies in Anbetracht der die
            Supportleistungen bedingenden Umstände verhältnismäßig ist.
          </Typography>
          <Typography component={'li'}>14.8. Vergütungsgutschrift</Typography>
          <Typography component={'li'}>
            Für den Fall, dass vorbehaltlich der Beschränkungen in Ziffer 15.8.
            in Cloud Connect eine der Funktionen nicht wie vereinbart verfügbar
            ist, gelten folgende Vergütungsgutschriftprozentsätze:
            Vergütungsgutschrift
          </Typography>

          <Typography component={'li'}>
            <LightTable
              columns={[
                {
                  field: 'availability',
                  headerName: 'Monatliche Verfügbarkeit',
                },
                {
                  field: 'downtime_minutes',

                  headerName: 'Ausfallzeit in Minuten',
                },
                {
                  field: 'remuneration',

                  headerName: 'Vergütungsgutschriftprozentsatz',
                },
              ]}
              rows={[
                {
                  availability:
                    'weniger als 98.5%, aber gleich oder größer 97.5%',
                  downtime_minutes: '877 < t <= 1096',
                  remuneration: '10%',
                },
                {
                  availability:
                    'weniger als 98.5%, aber gleich oder größer 97.0%',
                  downtime_minutes: '877 < t <= 1315',
                  remuneration: '25%',
                },
                {
                  availability: 'weniger als 97%',
                  downtime_minutes: 't < 1315',
                  remuneration: '50%',
                },
              ]}
            />
          </Typography>

          <Typography component={'li'}>
            14.9. Vergütungsgutschriften werden als Prozentsatz der vom Kunden
            gezahlten monatlichen Vergütung berechnet. Jede Vergütungsgutschrift
            wird nur mit zukünftigen, vom Kunden noch zu zahlender Vergütung
            verrechnet. Vergütungsgutschriften berechtigt den Kunden nicht von
            STÖRK Rückerstattungen oder andere Zahlungen – vorbehaltlich
            Schadenersatzansprüche – geltend zu machen. Eine Anrechnung der
            Vergütungsgutschrift auf die Vergütung erfolgt lediglich, sofern der
            Gutschriftbetrag für den entsprechenden monatlichen
            Abrechnungszyklus größer als 5 Euro ist. Vergütungsgutschrift sind
            nicht auf andere Kundenkonten übertragbar.
          </Typography>
          <Typography component={'li'}>
            14.10. Vergütungsgutschriften werden ausschließlich nach
            entsprechender Antragsstellung zumindest in Textform durch den
            Kunden an die Vertriebsabteilung von STÖRK bearbeitet. Der Antrag
            muss spätestens bis zum Ende des zweiten Abrechnungszyklus, nach dem
            die eingetreten ist, bei STÖRK eingehen und folgende Informationen
            enthalten:
          </Typography>
          <Typography component={'li'}>
            - Die Worte "Cloud Connect SLA – Antrag Vergütungsgutschrift“;
          </Typography>
          <Typography component={'li'}>
            - Datum, Uhrzeit und betroffenes Benutzerkonto;
          </Typography>
          <Typography component={'li'}>
            - genaue Dokumentation des Störfalles, z.B. Auszüge aus Cloud
            Connect Diagrammanzeigen
          </Typography>
          <Typography component={'li'}>
            Die ergänzende Geltendmachung von Minderungsansprüchen gemäß Ziffer
            17.5 ist ausgeschlossen.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          15. Service Level Agreement (SLA) für Cloud Connect
        </Typography>
        <ol>
          <Typography component={'li'}>
            15.1. STÖRK erbringt mit der Bereitstellung von Cloud Connect als
            SaaS-Lösung ausschließlich für den Kunden Supportleistungen nach
            Maßgabe der nachstehenden Regelungen während der vereinbarten
            Laufzeit. Die Vergütung für die Nutzung der SaaS-Dienstleistungen
            umfasst auch die Erbringung der Supportleistungen.
          </Typography>
          <Typography component={'li'}>
            15.2. Die Supportleistungen umfassen
          </Typography>
          <ol>
            <Typography component={'li'}>
              a. die Beseitigung von Mängeln;
            </Typography>
            <Typography component={'li'}>
              b. die Bereitstellung von neuen Programmständen und
            </Typography>
            <Typography component={'li'}>
              c. den Support-Helpdesk für den Kunden mit Bereitstellung des
              fachlichen und technischen Supports bei Problemen mit der Nutzung
              von Cloud Connect.
            </Typography>
          </ol>
          <Typography component={'li'}>
            Weitere Dienstleistungen sind gesondert zum vereinbarten Stunden-
            bzw. Tagessatz zu vergüten.
          </Typography>
          <Typography component={'li'}>
            15.3. Mangelanzeige durch Kunde
          </Typography>
          <Typography component={'li'}>
            Der Kunde zeigt mit entsprechender Beschreibung auftretende
            Störungen/Mängel (im Folgenden zusammen „Mängel“) von Cloud Connect
            an STÖRK per E-Mail mit (siehe Ziffer 5.2. lit. f.). STÖRK
            analysiert während der Servicezeiten Montag - Freitag von 09:00 bis
            16:00 Uhr MEZ aufnehmen (ausgenommen an den Deutschlandweit
            gesetzlichen Feiertagen) die Mängel und wird sich nach besten
            Kräften bemühen innerhalb angemessener Frist – wenn möglich
            innerhalb von 6 h - mit qualifizierten Mangelbeseitigungsmaßnahmen
            während der Geschäftszeiten zu beginnen.
          </Typography>
          <Typography component={'li'}>
            15.4. Form der Mangelbeseitigung
          </Typography>
          <Typography component={'li'}>
            STÖRK wird die angezeigten oder selbst festgestellten Mängel nach
            eigener Wahl durch eine der folgenden Maßnahmen beseitigen:
          </Typography>
          <ol>
            <Typography component={'li'}>
              a. Durch Aufspielen von neuen Programmständen;
            </Typography>
            <Typography component={'li'}>
              b. Handlungsanweisung an den Kunden zur Umgehung des Problems oder
              zur Mangelbeseitigung (Workaround). Der Kunde wird diese
              Handlungshinweise durch kompetentes Personal umsetzen, es sei denn
              dies ist ihm nicht zumutbar.
            </Typography>
          </ol>
          <Typography component={'li'}>
            15.5. Bereitstellung von neuen Programmständen
          </Typography>
          <ol>
            <Typography component={'li'}>
              a. Die Leistungspflicht von STÖRK zur Bereitstellung von neuen
              Programmständen umfasst das Aufspielen nach der jeweiligen
              Freigabe.
            </Typography>
            <Typography component={'li'}>
              b. Die Anwenderdokumentation wird an den jeweils aktuellen
              Programmstand angepasst.
            </Typography>
          </ol>
          <Typography component={'li'}>
            15.6. Support-Helpdesks für den Kunden
          </Typography>
          <Typography component={'li'}>
            Für die Erbringung eines Support-Helpdesks besteht die
            dienstvertragliche Verpflichtung von STÖRK, dem Kunden eine
            Benutzerhotline zur Verfügung zu stellen, die während der
            Servicezeiten von STÖRK zu erreichen ist. Die Benutzerhotline dient
            allein der Unterstützung des Kunden bei der Inanspruchnahme der nach
            dem SaaS-Vertrag geschuldeten Leistungen von STÖRK und zur Meldung
            von Funktionsstörungen durch den Kunden.
          </Typography>
          <Typography component={'li'}>
            15.7. Vergütungspflicht bei nicht bestehendem Mangel
          </Typography>
          <Typography component={'li'}>
            Stellt sich heraus, dass ein von dem Kunden mitgeteilter Mangel
            tatsächlich nicht besteht bzw. nicht auf eine sonstige
            Pflichtverletzung von STÖRK zurückzuführen ist, ist STÖRK
            berechtigt, die durch die Analyse und begonnene
            Mangelbeseitigungstätigkeiten entstandenen Kosten dem Kunden nach
            tatsächlichem Aufwand in Rechnung zu stellen und ist von dem Kunden
            zu vergüten.
          </Typography>
          <Typography component={'li'}>
            15.8. Eine Verpflichtung von STÖRK zur Erbringung von
            Supportleistungen gemäß Ziffer 15.2. lit. a. und b. besteht in
            folgenden Fällen nicht:
          </Typography>
          <ol>
            <Typography component={'li'}>
              a. sofern die angezeigten oder auftretenden Mängel von dem Kunden
              zu vertreten sind;
            </Typography>
            <Typography component={'li'}>
              b. Vertrags- oder gesetzeswidrige Handlungen oder Unterlassungen
              des Kunden;
            </Typography>
            <Typography component={'li'}>
              c.Vom Kunden verwendete Hardware, Software oder sonstige
              Umsysteme, die nicht den von STÖRK mitgeteilten
              Systemvoraussetzungen entsprechen;
            </Typography>
            <Typography component={'li'}>
              d. Bei Fehlfunktionen, die außerhalb des Kontroll- und
              Verantwortungsbereichs von STÖRK liegen;
            </Typography>
            <Typography component={'li'}>
              e. Ereignisse höherer Gewalt gemäß Ziffer 3.3.;
            </Typography>
            <Typography component={'li'}>
              f. Fehlfunktionen bedingt durch die Anbindung des Kunden an das
              Internet, die Aufrechterhaltung der Netzverbindung.
            </Typography>
          </ol>
        </ol>

        <Typography variant="h3" color={'primary'} component={'li'}>
          16. Sonstige Pflichten des Kunden
        </Typography>
        <ol>
          <Typography component={'li'}>
            16.1. Der Kunde wird auf eigene Kosten die Datenverbindung über das
            Internet zwischen den von ihm zur Nutzung vorgesehenen Nutzungsorten
            und dem von STÖRK definierten Datenübergabepunkt herstellen. Die
            Bedienung und Aufrechterhaltung dieser Datenverbindung liegt allein
            in der Verantwortung des Kunden. Dieser trägt die hierfür
            anfallenden Kosten.
          </Typography>
          <Typography component={'li'}>
            16.2. Der Kunde hat bei der Nutzung der SaaS-Dienstleistungen die
            jeweils geltenden gesetzlichen und behördlichen Bestimmungen in
            ihrer jeweils aktuellen Fassung stets einzuhalten und dies auf
            Verlangen STÖRK entsprechend nachzuweisen.
          </Typography>
          <Typography component={'li'}>
            16.3. . Der Kunde ist verpflichtet, die ihm zur Verfügung gestellten
            Zugangsdaten gegenüber unbefugten Dritten geheim zu halten und
            sicher vor dem Zugriff durch diese Dritte aufzubewahren, so dass ein
            Missbrauch der Zugangsdaten unmöglich ist. Sobald der Kunde
            Anzeichen dafür hat, dass die Zugangsdaten von einem unbefugten
            Dritten unrechtmäßig erlangt wurden oder missbraucht werden könnten,
            ist der Kunde verpflichtet, STÖRK unverzüglich zumindest in Textform
            zu informieren.
          </Typography>
          <Typography component={'li'}>
            16.4. Der Kunde ist verpflichtet, STÖRK alle für die Durchführung
            der von dieser für die Erbringung der vertraglich geschuldeten
            Leistungen relevanten Änderungen zu seinem Unternehmen in Textform
            mitzuteilen. Hierzu gehören insbesondere Änderungen zur
            Geschäftsanschrift, Firma oder Rechtsform sowie der zuständigen
            Ansprechpartner des Kunden.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          17. Sach- und Rechtsmängel bei Saas-Lösung
        </Typography>
        <ol>
          <Typography component={'li'}>
            17.1. STÖRK gewährleistet die Funktions- und die
            Betriebsbereitschaft der SaaS- Lösung nach den Bestimmungen dieses
            Vertrages. Technische Daten, Spezifikationen und Leistungsangaben in
            öffentlichen Äußerungen, insbesondere in den Präsentationsunterlagen
            / Produktflyern sind keine Beschaffenheitsangaben. Im Übrigen muss
            sich die SaaS-Lösung für die nach dem geschlossenen Vertrag
            vorausgesetzte Verwendung eignen und ansonsten eine Beschaffenheit
            aufweisen, die bei einer SaaS-Lösung der gleichen Art üblich ist.
            Ein Rechtsmangel liegt vor, wenn dem Kunden für die vertragliche
            Verwendung des Vertragsgegenstandes in Europa, USA und Kanada die
            erforderlichen Rechte nicht wirksam eingeräumt werden konnten.
          </Typography>
          <Typography component={'li'}>
            17.2. Sofern durch den Kunden oder von ihm beauftragte Dritte – ohne
            die Einwilligung von STÖRK zumindest in Textform – Eingriffe in die
            von STÖRK bereitgestellte SaaS-Lösung vorgenommen werden,
            insbesondere Manipulationen oder sonstige Änderungen, leistet STÖRK
            nur dann Mangelbeseitigung, wenn der Kunde nachweist, dass der
            Eingriff in keinem Zusammenhang mit dem aufgetretenen Mangel steht
            und Analyse sowie Behebung nicht erschweren.
          </Typography>
          <Typography component={'li'}>
            17.3. Der Anspruch des Kunden auf Nacherfüllung ist ausgeschlossen,
            wenn der Mangel nicht reproduzierbar ist bzw. anhand von
            handschriftlich oder maschinell festgehaltenen Ausdrucken nicht
            aufgezeigt werden kann.
          </Typography>
          <Typography component={'li'}>
            17.4. Der Kunde hat Mängel in Cloud Connect gemäß Ziffer 15.3.
            anzuzeigen. Die Pflicht zur Erhaltung beinhaltet nicht die Anpassung
            der SaaS-Lösung an veränderte Einsatzbedingungen und technische und
            funktionale Entwicklungen, wie Veränderungen der IT-Umgebung,
            insbesondere Änderung der Hardware oder des Betriebssystems,
            Anpassung an den Funktionsumfang konkurrierender Produkte oder
            Herstellung der Kompatibilität zu neuen Datenformaten. Bei
            berechtigten Mängelrügen wird STÖRK gemäß den Bestimmungen in Ziffer
            15.4. und 15.5. die Mängel beseitigen.
          </Typography>
          <Typography component={'li'}>
            17.5. Soweit STÖRK die Behebung des Mangels auch im zweiten Versuch
            nach erneut angemessener Frist nicht gelingt, kann der Kunde die
            vereinbarte Vergütung anteilig für die Zeiten mindern, in der die
            SaaS-Lösung nicht in dem vereinbarten Umfang zur Verfügung stand.
            Das Recht zur Minderung ist der Höhe nach auf die auf den
            mangelhaften Leistungsbestandteil entfallende monatliche Vergütung
            beschränkt.
          </Typography>
          <Typography component={'li'}>
            17.6. Für die Nacherfüllung bei Rechtsmängeln ist die Regelung in
            Ziffer 10.5 entsprechend anzuwenden.
          </Typography>
          <Typography component={'li'}>
            17.7. Die Verjährungsfrist für Mangelbeseitigungsansprüche der
            SaaS-Lösung beträgt ein Jahr.
          </Typography>
          <Typography component={'li'} fontWeight={'bold'}>
            Besondere Bestimmungen zu IT-bezogenen Dienstleistungen
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          18. Vertragsgegenstand sonstige IT-bezogene Dienstleistungen
        </Typography>
        <Typography component={'li'}>
          Erbringt STÖRK insbesondere Dienstleistungen wie Installation der
          Software, Programmierung zusätzlicher Programmteile
          (Software-Erstellung), Datenüber- nahme, Konvertierung,
          Parametrisierung, Einweisung in die Nutzung von Soft- und Hardware,
          Durchführung von Schulungen, Beratung und Projektleitung, Customizing
          wie Anpassen (mit Änderung des Quellcode) oder Einrichten/Einstellen
          (Parametrisierung) der Software, das Einrichten von Hardware, sowie
          Erstellung Pflichtenheft erbringen, gelten ergänzend die Regelungen in
          Ziffer 19 f.
        </Typography>
        <Typography variant="h3" color={'primary'} component={'li'}>
          19. Leistungserbringung und –umfang / Beschränkungen
        </Typography>
        <ol>
          <Typography component={'li'}>
            19.1. Das Angebot enthält die zu erbringende Dienstleistungen mit
            Regelungen z.B. hinsichtlich ihrer konkreten Aufgabenstellung, der
            Vergütung, der Vertragslaufzeit, Leistungsort, zeitlichem Umfang
            etc.
          </Typography>
          <Typography component={'li'}>
            19.2. Die Auswahl und die Einteilung der Mitarbeitenden bleibt STÖRK
            vorbehalten.
          </Typography>
          <Typography component={'li'}>
            19.3. STÖRK übergibt an den Kunden die Dokumentation der
            Arbeitsergebnisse der jeweils erbrachten Leistungen spätestens mit
            vollständiger Vergütung.
          </Typography>
          <Typography component={'li'}>
            19.4. Ansprüche des Kunden auf Erbringung von beauftragten und im
            Voraus vergüteten Dienstleistungen erlöschen ohne
            Rückzahlungsverpflichtung von STÖRK, sofern diese nicht spätestens
            12 Monate nach Auftragserteilung von dem Kunden abgerufen werden.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          20. Besondere Bestimmungen bei Schulungen
        </Typography>
        <ol>
          <Typography component={'li'}>
            20.1. Die Teilnahme an Schulungen bedarf der namentlichen
            verbindlichen Anmeldung der Teilnehmenden zumindest in Textform. Das
            Honorar und etwaige Nebenkosten sind vor Beginn der Schulung zu
            entrichten. Bei Rücktritt von der Teilnahme ist STÖRK spätestens 2
            Wochen vor Beginn der Veranstaltung zumindest in Textform zu
            benachrichtigen. In diesem Fall beträgt die Ausfallentschädigung 1/3
            des fälligen Honorars. Erfolgt der Rücktritt innerhalb einer
            kürzeren Frist oder bleibt ein Teilnehmender/eine Teilnehmende der
            Schulung fern, ist das vereinbarte Honorar und die Nebenkosten in
            voller Höhe zur Zahlung fällig.
          </Typography>
          <Typography component={'li'}>
            20.2. STÖRK behält sich vor, die Schulung abzusagen. Angemeldete
            Teilnehmende werden so frühzeitig wie möglich verständigt, es sei
            denn, höhere Gewalt verhindert dies. Bereits von den Teilnehmenden
            bezahlte Honorare werden zurückerstattet. Den Teilnehmenden
            entstandener Schaden hat STÖRK nur unter den Voraussetzungen von
            Ziffer 11 der AGB zu erstatten.
          </Typography>
          <Typography component={'li'}>
            20.3. Inhalte und Qualität der Schulung orientieren sich am jeweils
            aktuellen allgemein verfügbaren Stand der die Materie betreffenden
            Erkenntnisse. Eine Gewähr für unvollständige oder unrichtige Inhalte
            oder/und Begleitmaterialien übernimmt STÖRK nicht.
          </Typography>
        </ol>
        <Typography component={'li'} fontWeight={'bold'}>
          Allgemeine Schlussbestimmungen
        </Typography>
        <Typography variant="h3" color={'primary'} component={'li'}>
          21. Formerfordernisse
        </Typography>
        <ol>
          <Typography component={'li'}>
            21.1. Mündliche Nebenabreden sind nicht getroffen, Änderungen oder
            Ergänzungen der AGB sowie der zwischen STÖRK und dem Kunden
            geschlossenen Verträge bedürfen zu ihrer Wirksamkeit der
            Schriftform. Das Formerfordernis ist auch gewahrt durch die
            Verwendung einer einfachen elektronischen Signatur oder einer
            qualifizierten elektronischen Signatur im Sinne des § 126a BGB (z.
            B. DocuSign). § 127 Abs. 2 und 3 BGB finden in diesen beiden Fällen
            keine Anwendung.
          </Typography>
          <Typography component={'li'}>
            21.2. Kündigungen bedürfen zu ihrer Wirksamkeit zumindest der
            Schriftform.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          22. Erfüllungsort / Anwendbares Recht / Gerichtsstand
        </Typography>
        <ol>
          <Typography component={'li'}>
            22.1. Erfüllungsort für Lieferungen und Leistungen sowie Ort der
            Nacherfüllung ist Stuttgart.
          </Typography>
          <Typography component={'li'}>
            22.2. Diese AGB und auf ihrer Grundlage geschlossene Verträge
            unterliegen dem Recht der Bundesrepublik Deutschland unter
            Ausschluss des UN-Kaufrechts.
          </Typography>
          <Typography component={'li'}>
            22.3. Ist der Kunde Kaufmann, juristische Person des öffentlichen
            Rechts oder öffentlich-rechtliches Sondervermögen, ist Gerichtsstand
            für alle Streitigkeiten Stuttgart. STÖRK ist berechtigt, eigene
            Ansprüche am Gerichtsstand des Kunden geltend zu machen.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          23. Abtretung / Salvatorische Klausel
        </Typography>
        <ol>
          <Typography component={'li'}>
            23.1. Ansprüche aus mit STÖRK abgeschlossenen Verträgen kann der
            Kunde nur mit der vorherigen schriftlichen Zustimmung von STÖRK
            abtreten. Die Zustimmung darf von STÖRK nicht aus unbilligen Gründen
            verweigert werden.
          </Typography>
          <Typography component={'li'}>
            23.2. Sollten einzelne Bestimmungen dieser AGB ganz oder teilweise
            unwirksam sein oder werden, oder sollte sich in den AGB eine Lücke
            befinden, so soll hierdurch die Gültigkeit der übrigen Bestimmungen
            nicht berührt werden.
          </Typography>
        </ol>
        <Typography variant="h3" color={'primary'} component={'li'}>
          24. Sprache und Geltungsvorrang der deutschen Sprachversion
        </Typography>
        <Typography component={'li'}>
          Diese AGB und der SaaS-Vertrag wurden in deutscher Sprache erstellt.
          Im Falle ihrer Übersetzung in die englische Sprache geht bei
          inhaltlichen Abweichungen zwischen den beiden Sprachversionen die
          deutsche Sprachversion vor.
        </Typography>
      </Box>
    </>
  );
}

export default TermsContentDe;
